var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full text-gray-300 mb-1   rounded mx-1 lg:mx-0"},[_c('div',{staticClass:"flex flex-col w-full sm:flex-row ",class:[{ 'opacity-50': !_vm.enabled }]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }